export interface ShareData {
    title?: string;
    url?: string;
    text?: string;
    files?: File[];
  }